import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import "./FilterList.scss";

const FilterList = () => {

    const [sortBy, setSortBy] = useState(false);

    const showSortBy = () => {
      setSortBy(!sortBy);
    };
    return (
        <>
        <div className="row d-flex justify-content-end mr-1">
                <div className="featured">
                  <h6>SORT BY : </h6>

                  <button className="featured__btn" onClick={showSortBy}>
                    FEATURED <i class="fas fa-sort fa-1x"></i>
                  </button>
                  {sortBy ? (
                    <div className="featured__list">
                      <Link to="/category/Filter">Price, Low to High</Link>
                      <Link to="/category/Filter">Price, High to Low</Link>
                      <Link to="/category/Filter">A-Z</Link>
                      <Link to="/category/Filter">Z-A</Link>
                      <Link to="/category/Filter">Best Selling</Link>
                    </div>
                  ) : null}
                </div>
              </div>
            
        </>
    )
}

export default FilterList;
